module.exports = "<div class=\"tct-form-error-presenter\">\n  {{$ctrl.fields}}- <span translate=\"{{$ctrl.descr_translatekey | translate}}\"></span>\n</div>\n";